import { useQuery } from '@tanstack/react-query';
import { getProviderActivation } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';

export const useProviderActivationQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'provider', providerId, 'activation' ],
    queryFn: async () => {
      try {
        const response = await getProviderActivation(providerId);

        return response.data;
      } catch (error) {
        return null;
      }
    },
    retry: false,
    ...opts,
  });
};
